<template>
  <div>

    <breadcrumbs />

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.bonus_calculator }}
              </h6>
              <div class="element-box-tp">
                <bonusCalculatorForm ref="cal" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--------------------
      START - Sidebar
      -------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>

        <userWidget v-intro="tinfo.LAST_LOGINS" v-intro-position="'left'" :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />

        <userWidget v-intro="tinfo.LAST_ACTIVITY" v-intro-position="'left'" :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />

        <trendWidget v-intro="tinfo.TREND_SPORT_EVENTS" v-intro-position="'left'" />
      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>
  </div>
</template>

<script>

  import userWidget from '@/components/user/widget/userWidget'
  import trendWidget from '@/components/user/bets/widget/trends'
  import bonusCalculatorForm from '@/components/reports/form/bonusCalculatorForm'

    export default {
        name: 'bonusCalculator',
        components: { bonusCalculatorForm,userWidget,trendWidget },
        data () {
            return {
                t: this.$root.t,
                tinfo: this.$root.tinfo,
                result: []
            }
        },
        watch: {
            '$refs.cal.result' (n,o) {
                console.log(o);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/accounting/BonusCalculator.vue